
















import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';
import SharedFacilityDayCalendar from '@/components/Admin/Panels/SharedFacilities/SharedFacilityDayCalendar.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component({
    components: {
        SharedFacilityDayCalendar,
    },
    computed: {
        ...mapGetters({
            facility: 'SharedFacilities/getActiveAdminFacility',
            facilityBookings: 'SharedFacilities/getActiveFacilityBookings',
        }),
    },
})
export default class SharedFacilitiesCalendarForm extends Mixins(LocalizationMethods) {
    public date: any = null;

    constructor() {
        super();
    }

    get calendarMaskOptions() {
        return {
            title: 'MMMM YYYY',
            weekdays: 'WWW',
        };
    }

    get activeFacility() {
        return this.$store.getters['SharedFacilities/getActiveAdminFacility'];
    }

    get activeFacilityBookings() {
        return this.$store.getters['SharedFacilities/getActiveFacilityBookings'];
    }

    get facilityBookedDays() {
        const bookings = this.activeFacilityBookings;
        const dot = {
                color: 'red',
                class: 'booked-cal-dots booked-cal-dots-red',
            };
        const dates = [];
        for (const booking of bookings) {
            dates.push(new Date(booking.startTime));
        }
        return [{ dot, dates }];
    }

    public selectedDate() {
        const day = String(this.date.getDate());
        const month = String(this.date.getMonth() + 1);
        const year = String(this.date.getFullYear());
        return `${year}-${month.length === 1 ? '0' + month : month}-${day.length === 1 ? '0' + day : day}`;
    }

    @Watch('activeFacility')
    public activeFacilityChanged() {
        this.date = null;
    }

    @Watch('date')
    public dayChanged() {
        if (this.date) {
            const bookings = this.activeFacilityBookings;
            const currentDate = this.selectedDate();
            const currentDateBookings = [];
            for (const booking of bookings) {
                if (booking.startTime.indexOf(currentDate) !== -1) {
                    currentDateBookings.push(booking);
                }
            }
            this.$store.commit(Mutations.SET_ADMIN_CALENDAR_SELECTED_DATE, this.date);
            this.$store.commit(Mutations.SET_ADMIN_ACTIVE_FACILITY_SELECTED_DATE_BOOKINGS, currentDateBookings);
        }
    }
}
